import { TemplateRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SelectableSource } from 'src/app/models/generation/generation.model';
import { DocumentVersionInfo } from 'src/app/models/documents/document-version.model';
import { ContextMenuMode, DriveItem, ItemType } from './drive-viewer.models';

export class DriveWorkspaceState {
  items: DriveItem[] = [];
  readonly expanded = new Set<string>();
  isRefreshingTree = false;
  isLoadingFiles = false;
  currentFolderId = '';
  view: 'list' | 'grid' = 'list';
  sortKey: 'name' | 'type' | 'owner' | 'modified' | 'size' = 'name';
  sortDir: 'asc' | 'desc' = 'asc';
  search = '';
  filterType: ItemType | 'all' = 'all';
  filterOwner: 'you' | 'external' | 'any' | 'all' = 'all';
  readonly selectedIds = new Set<string>();
  detailsOpen = false;
  mobileTreeOpen = false;
  mobileFiltersOpen = false;
  active = true;
  treeBuffer: DriveItem[] = [];
}

export class DrivePreviewState {
  previewOpen = false;
  previewIndex = 0;
  previewItemOverride?: DriveItem;
  readonly previewLoadingIds = new Set<string>();
  previewErrors: Record<string, string> = {};
}

export class DriveMoveState {
  contextMenuVisible = false;
  menuX = 0;
  menuY = 0;
  contextFolderId: string | null = null;
  contextMenuMode: ContextMenuMode = 'folder';
  contextMenuItem?: DriveItem;
  contextMoveExpanded = false;
  moveDialogFiles: DriveItem[] = [];
  moveDialogSearch = '';
  moveDialogBusy = false;
  moveDialogError = '';
  deleteDialogItem?: DriveItem;
  deleteDialogName = '';
  deleteDialogBusy = false;
  deleteDialogRef?: MatDialogRef<unknown>;
  isDraggingFile = false;
  dragHoverFolderId: string | null = null;
  newFolderName = '';
  currentDialogRef?: MatDialogRef<unknown>;
  moveDialogRef?: MatDialogRef<unknown>;
  nativeDraggedItem?: DriveItem;
  readonly pendingMoveKeys = new Set<string>();
  createFolderDialogTpl?: TemplateRef<unknown>;
}

export class DriveSummaryState {
  summarySources: SelectableSource[] = [];
  summaryDialogRef?: MatDialogRef<unknown>;
  generateSummaryDialogTpl?: TemplateRef<unknown>;
}

export class DriveVersionState {
  versionsDialogTpl?: TemplateRef<unknown>;
  docVersioningEnabled = false;
  versionBadges: Record<string, number> = {};
  versionHistory: DocumentVersionInfo[] = [];
  versionHistoryLoading = false;
  versionHistoryError = '';
  versionHistoryItem?: DriveItem;
  versionsDialogRef?: MatDialogRef<unknown>;
}
